<template>
    <b-alert variant="warning" :show="alertEnabled && hasValidationErrors && !alertDismissed" dismissible v-on:dismissed="alertDismissed = true">
        Please correct the following input errors:
        <ul>
            <li v-for="(error, index) in validationErrors" :key="index">
                {{ error }}
            </li>
        </ul>
    </b-alert>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';

    import ErrorsMixin from '../mixins/ErrorsMixin';

    Vue.use(BootstrapVue);

    export default {
        name: 'ValidationSummary',
        mixins: [ErrorsMixin],
        props: {
            veeValidateObserverErrors: {
                required: true
            },
            alertEnabled: {
                type: Boolean,
                default: false,
            },
            toastEnabled: {
                type: Boolean,
                default: true,
            }
        },
        data: function () {
            return {
                validationErrors: [],
                hasValidationErrors: false,
                alertDismissed: true,
                toastActive: false
            };
        },
        watch: {
            veeValidateObserverErrors: function () {
                this.validationErrors = [];
                for (var key in this.veeValidateObserverErrors) {
                    var validationProviderErrors = this.veeValidateObserverErrors[key];
                    if (validationProviderErrors instanceof Array) {
                        validationProviderErrors.forEach(validationError => this.validationErrors.push(validationError));
                    }
                }
                this.hasValidationErrors = this.validationErrors.length > 0;
                this.handleValidationErrors();
            }
        },
        methods: {
            activate: function () {
                if (this.toastEnabled) this.toastActive = true;
                if (this.alertEnabled) this.alertDismissed = false;
                this.handleValidationErrors();
            },
            handleValidationErrors: function () {
                if (this.toastActive && this.hasValidationErrors) {
                    this.showErrorsToast(this.validationErrors, 'Please correct the following input errors', false);
                    this.toastActive = false;
                }
            }
        }
    }
</script>